import { Action } from '@ngrx/store';
import { Lilate, LilateList } from '../../model/lilate.model';
import { LilateActionsUnions, LilateActionTypes } from '../actions/lilate.actions';

export interface LilateData {
    lilateList: LilateList | null;
    lilatesDone: Lilate[] | null;
    lilatesUpcoming: Lilate[] | null;
    loading: boolean,
    hasError: boolean,
    message: string | null
}

export const initialState: LilateData = {
    lilateList: null,
    lilatesDone: null,
    lilatesUpcoming: null,
    loading: false,
    hasError: false,
    message: null
};

export function reducer(state = initialState, action: LilateActionsUnions): LilateData {
    switch (action.type) {
        case LilateActionTypes.GET_LIST_PAST: {
            return { ...state, loading: true };
        }
        case LilateActionTypes.GET_LIST_UPCOMING: {
            return { ...state, loading: true, hasError: false };
        }
        case LilateActionTypes.GET_LIST_SUCCESS: {
            if (action.upcoming) {
                return {
                    ...state,
                    lilatesUpcoming: action.payload.results ?? [],
                    loading: false,
                    hasError: false,
                }
            } else {
                return {
                    ...state,
                    lilatesDone: action.payload.results ?? [],
                    loading: false,
                    hasError: false,
                };
            }
        }
        case LilateActionTypes.GET_LIST_FAILURE: {
            return {
                ...state,
                lilatesUpcoming: [],
                loading: false,
                hasError: true,
            }
        }
        case LilateActionTypes.PATCH_LILATE: {
            return { ...state, loading: true };
        }
        case LilateActionTypes.PATCH_SUCCESS: {
            return { ...state, loading: false };
        }
        case LilateActionTypes.PATCH_FAILURE: {
            return { ...state, loading: false };
        }
        case LilateActionTypes.PLAN_LILATE: {
            return { ...state, loading: true };
        }
        case LilateActionTypes.PLAN_SUCCESS: {
            return { ...state, loading: false };
        }
        case LilateActionTypes.PLAN_FAILURE: {
            return { ...state, loading: false };
        }
        case LilateActionTypes.GET_LISTING: {
            return {
                ...state,
                loading: true
            }
        }
        case LilateActionTypes.GET_LISTING_SUCCESS: {
            return {
                ...state,
                lilateList: action.payload,
                loading: false
            }
        }
        case LilateActionTypes.GET_LISTING_FAILURE: {
            return {
                ...state,
                lilateList: null,
                loading: false
            }
        }
        case LilateActionTypes.GET_LISTING_URL: {
            return {
                ...state,
                loading: false
            }
        }
        default: {
            return state;
        }
    }
}